import { cn } from "@/lib/utils";
import Link from "next/link";
import { useRouter } from "next/router";
import React, { Fragment } from "react";
import useSWR from "swr";

const fetcher = (...args) => fetch(...args).then((res) => res.json());

export default function SideBarBlog({ item, className }) {
    const { data: relatedData } = useSWR(
        `https://univest.in/blogs-2/wp-json/wp/v2/posts?per_page=6&category=${item.categories}`,
        fetcher
    );
    return (
        <div className={cn("w-full border rounded-md mt-4 ", className)}>
            <p className="px-3 py-[10px] text-sm text-[#808080]">Related Posts</p>
            <hr />
            {relatedData
                ?.filter((e) => e.id != item.id)
                ?.map((ele) => (
                    <Link key={ele.id} href={`/blogs/${ele.slug}`}>
                        <p className="text-sm font-semibold px-3 py-[10px] hover:opacity-75 text-black cursor-pointer">
                            {ele?.title?.rendered == "Weekly Update"
                                ? `Weekly Update - ${new Date(ele.date).toDateString()}`
                                : `${ele?.title?.rendered}`}
                        </p>
                        <hr />
                    </Link>
                ))}
        </div>
    );
}
export function SideBarBlogServe({ relatedData, className, item }) {
    return (
        <div className={cn("w-full border rounded-md mt-4 ", className)}>
            <p className="px-3 py-[10px] text-sm text-[#808080]">Related Posts</p>
            <hr />
            {relatedData
                ?.filter((e) => e.id != item.id)
                ?.map((ele) => (
                    <Link key={ele.id} href={`/blogs/${ele.slug}`}>
                        <p className="text-sm font-semibold px-3 py-[10px] hover:opacity-75 text-black cursor-pointer">
                            {ele?.title?.rendered == "Weekly Update"
                                ? `Weekly Update - ${new Date(ele.date).toDateString()}`
                                : `${ele?.title?.rendered}`}
                        </p>
                        <hr />
                    </Link>
                ))}
        </div>
    );
}

export function SideBarBlogCategories() {
    const { data: relatedData } = useSWR(`https://univest.in/blogs-2/wp-json/wp/v2/categories`, fetcher);
    return (
        <div className="w-full border rounded-md mt-4 ">
            <p className="px-3 py-[10px] text-sm text-[#808080]">Blog Categories</p>
            <hr />
            {relatedData
                ?.filter((f) => f?.count > 0 && f?.name !== "Uncategorized")
                .map((ele) => (
                    <Link
                        key={ele.id}
                        href={`/blogs/category/${ele?.slug}`}
                        className="flex justify-between items-center border-b"
                    >
                        <div className="text-sm font-semibold px-3 py-[10px] hover:opacity-75 text-black">
                            {ele.name}
                        </div>
                        <div className="text-sm font-semibold px-3 py-[10px] hover:opacity-75 text-black">
                            {ele.count}
                        </div>
                    </Link>
                ))}
        </div>
    );
}
